import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) =>
    path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

  return (
    <header className="header">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <div className="container header-inner">
        <Link to="/" className="logo">
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/logo-white.png`}
            alt="LeadingNG"
            className="logo-img"
          />
        </Link>
        <button
          type="button"
          className="nav-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((o) => !o)}
        >
          <span />
          <span />
          <span />
        </button>
        <nav className={`main-nav ${open ? 'open' : ''}`}>
          <ul className="nav-list">
            <li>
              <Link
                to="/"
                className={isActive('/') && location.pathname === '/' ? 'active' : ''}
                onClick={() => setOpen(false)}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about-us"
                className={isActive('/about-us') ? 'active' : ''}
                onClick={() => setOpen(false)}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/projects"
                className={isActive('/projects') ? 'active' : ''}
                onClick={() => setOpen(false)}
              >
                Projects
              </Link>
            </li>
            <li>
              <Link
                to="/app"
                className={isActive('/app') ? 'active' : ''}
                onClick={() => setOpen(false)}
              >
                Apps
              </Link>
            </li>
            <li>
              <Link
                to="/contact-us"
                className={isActive('/contact-us') ? 'active' : ''}
                onClick={() => setOpen(false)}
              >
                Contact
              </Link>
            </li>
          </ul>
        </nav>
      </div>

      <style>{`
        .header {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          height: var(--header-height);
          background: rgba(30, 42, 54, 0.97);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          border-bottom: 1px solid rgba(255, 255, 255, 0.06);
          z-index: 1000;
          display: flex;
          align-items: center;
        }
        .header-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .logo { display: block; }
        .logo-img { height: 42px; width: auto; display: block; }
        .nav-toggle {
          display: none;
          flex-direction: column;
          gap: 5px;
          background: none;
          border: none;
          cursor: pointer;
          padding: 8px;
        }
        .nav-toggle span {
          width: 24px;
          height: 2px;
          background: #fff;
        }
        .main-nav ul {
          list-style: none;
          margin: 0;
          padding: 0;
          display: flex;
          gap: 28px;
        }
        .main-nav a {
          color: rgba(255, 255, 255, 0.92);
          font-weight: 600;
          font-size: 0.95rem;
          text-decoration: none;
          transition: color 0.2s ease;
        }
        .main-nav a:hover,
        .main-nav a.active {
          color: var(--color-primary);
          text-decoration: none;
        }
        @media (max-width: 768px) {
          .nav-toggle { display: flex; }
          .main-nav {
            position: absolute;
            top: var(--header-height);
            left: 0;
            right: 0;
            background: var(--color-bg-dark);
            border-bottom: 1px solid rgba(255,255,255,0.08);
            padding: 20px;
            display: none;
          }
          .main-nav.open { display: block; }
          .main-nav ul { flex-direction: column; gap: 12px; }
        }
        @media (min-width: 769px) {
          .main-nav { display: block !important; }
        }
      `}</style>
    </header>
  );
}
